import { TableCell as SLTableCell } from "@skylead/component-library"
import React from "react"
import { Link } from "react-router-dom"

import { useGlobalTranslation } from "../../../utils/hook"
import { hasPermission } from "../../../utils/team-management/team-management-utils"

const TableCell = ({
  cellType,
  tableCellWrapperClassName,
  setTooltip,
  closeTooltip,
  onChange,
  iconClassname,
  iconOnClick,
  // Checkbox props
  checkboxIcon,
  isCheckboxChecked,
  checkboxOnClick,
  isCheckboxDisabled,
  // Radio props
  isRadioButtonChecked,
  isRadioButtonDisabled,
  radioButtonName,
  // Icon props
  icon,
  // Toggle props
  switchInitChecked,
  switchDisabled = false,
  labelType,
  // Text props
  text,
  helperText,
  link,
  textCellIcon,
  tooltipText,
  inputButton,
  // Stat props
  statColor,
  statShowPercentage,
  // Status props
  statusIcon,
  statusColor,
  statusTooltip,
  // Progress bar props
  progressPercentage,
  progressTotal,
  // Weekday props
  weekdayIntervals,
  className,
  // Avatar props
  name,
  imgSource,
}) => {
  const { tt } = useGlobalTranslation()
  return (
    <SLTableCell
      cellType={cellType}
      tableCellWrapperClassName={tableCellWrapperClassName}
      setTooltip={setTooltip}
      closeTooltip={closeTooltip}
      onChange={onChange}
      iconClassname={iconClassname}
      iconOnClick={iconOnClick}
      checkboxIcon={checkboxIcon}
      isCheckboxChecked={isCheckboxChecked}
      checkboxOnClick={checkboxOnClick}
      isCheckboxDisabled={isCheckboxDisabled}
      isRadioButtonChecked={isRadioButtonChecked}
      isRadioButtonDisabled={isRadioButtonDisabled}
      radioButtonName={radioButtonName}
      icon={icon}
      switchInitChecked={switchInitChecked}
      switchDisabled={switchDisabled}
      labelType={labelType}
      text={text}
      helperText={helperText}
      link={link}
      textCellIcon={textCellIcon}
      tooltipText={tooltipText}
      inputButton={inputButton}
      statColor={statColor}
      statShowPercentage={statShowPercentage}
      statusIcon={statusIcon}
      statusColor={statusColor}
      statusTooltip={statusTooltip}
      progressPercentage={progressPercentage}
      progressTotal={progressTotal}
      weekdayIntervals={weekdayIntervals}
      className={className}
      name={name}
      imgSource={imgSource}
      hasPermission={hasPermission}
      LinkComponent={Link}
      tt={tt}
    />
  )
}

// TableCell.propTypes = {
//   cellType: PropTypes.oneOf(Object.values(CELL_VARIANT)),
//   onChange: PropTypes.func,
//   checkboxIcon: PropTypes.string,
//   isCheckboxChecked: PropTypes.bool,
//   checkboxOnClick: PropTypes.func,
//   isCheckboxDisabled: PropTypes.bool,
//   isRadioButtonChecked: PropTypes.bool,
//   isRadioButtonDisabled: PropTypes.bool,
//   radioButtonName: PropTypes.string,
//   icon: PropTypes.string,
//   switchInitChecked: PropTypes.bool,
//   switchDisabled: PropTypes.bool,
//   text: PropTypes.string,
//   helperText: PropTypes.string,
//   link: PropTypes.string,
//   textCellIcon: PropTypes.string,
//   statColor: PropTypes.string,
//   statusIcon: PropTypes.string,
//   progressPercentage: PropTypes.string,
//   progressTotal: PropTypes.string,
//   weekdayIntervals: PropTypes.instanceOf(Object),
//   setTooltip: PropTypes.func,
//   closeTooltip: PropTypes.func,
//   name: PropTypes.string,
//   imgSource: PropTypes.string,
// }

export default TableCell
